import { createContext } from "preact/compat";
export const WishlistContext = createContext(null);
